import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';

import { showSkillsEvaluationsEditDialog } from './skills-evaluations/SkillsEvaluationsEditDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'skills'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'skills', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'skills'),
				action: ({ model, t }) => {
					const { skll_title } = model;
					Utils.openLink({
						pathname: '/skills/add',
						state: {
							model: { ...model, skll_title: skll_title + t('COPY') }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(showAddNotesDialog({ model: { note_table: 'dems', note_table_uid: model.dems_uid } }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'skills'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'skills',
							id: model.skll_uid,
							title: model.skll_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'skills'),
				action: ({ dispatch, updateRefresh }) =>
					dispatch(showFastAddDialog({ module: 'skills', updateRefresh }))
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'items'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'skills'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'skills',
							id: model.skll_uid,
							title: model.skll_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'skills'),
				action: ({ switchEdit }) => switchEdit()
			},
			{
				id: 'evaluations',
				name: 'DETAILS_HEADER_BUTTON_NEW_SKILL_EVALUATION',
				icon: 'book-check',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('skills_evaluations') || authorizer.cannot('create', 'skills_evaluations'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showSkillsEvaluationsEditDialog({
							model: { skev_skll_uid: model.skll_uid },
							isAdd: true,
							updateRefresh
						})
					)
			}
			// {
			// 	id: 'courses',
			// 	name: 'DETAILS_HEADER_BUTTON_NEW_COURSE',
			// 	icon: 'school',
			// 	iconAdd: true,
			// 	hidden: ({ isModuleDisabled, authorizer }) =>
			// 		isModuleDisabled('courses') || authorizer.cannot('create', 'courses'),
			// 	action: ({ dispatch, updateRefresh, model }) =>
			// 		dispatch(
			// 			showFastAddDialog({
			// 				module: 'courses',
			// 				updateRefresh,
			// 				model: {
			// 					crss_skll_uid: model.skll_uid
			// 				}
			// 			})
			// 		)
			// }
		]
	}
};

export default buttons;
